import React, { useEffect, useState } from "react";
import { lngDetect } from "../../../helpers/lngDetect";
import { useOutletContext } from "react-router-dom";
import Image from "../../elements/Image";
import NoData from "../../elements/Nodata";
import noDataImage from "../../../assets/images/tickets.svg";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { ticketList } from "../../../services/ticketService";

const OrderSummaryInfo = ({ checkoutData = [] }) => {
  const { t } = useTranslation();
  const { eventOrganizer, event } = useOutletContext();
  const [totalPrice, setTotalPrice] = useState(0);
  const [transactionPrice, setTransactionPrice] = useState(0);
  const [taxPrice, setTaxPrice] = useState(0);
  const [subTotal, setSubtotal] = useState(0);

  const calculateFeeSettings = (params) => {
    try {
      let application_fee_amount = 0;
      params?.feeSettingArray?.forEach((fee) => {
        if (fee.type === "percent") {
          application_fee_amount += params.orderTotal * fee.amount;
        } else if (fee.type === "fixed") {
          application_fee_amount += fee.amount;
        }
      });

      return { transactionFee: application_fee_amount };
    } catch (error) {
      return {
        status: 500,
        success: false,
        error: error.message,
      };
    }
  };

  useEffect(() => {
    if (
      checkoutData &&
      Array.isArray(checkoutData) &&
      checkoutData?.length > 0
    ) {
      const total_price = checkoutData?.reduce((acc, item) => {
        return acc + parseFloat(item?.totalPrice);
      }, 0);
      const orderTotal = checkoutData?.reduce((acc, item) => {
        return acc + parseFloat(item?.totalPrice);
      }, 0);

      const transaction_fee = calculateFeeSettings({
        feeSettingArray: eventOrganizer?.data?.feeSetting,
        orderTotal,
      })?.transactionFee;

      const tax = calculateFeeSettings({
        feeSettingArray: eventOrganizer?.data?.taxData?.map((item) => ({
          ...item,
          amount: item?.rate,
          type: "percent",
        })),
        orderTotal: (orderTotal || 0) + (transaction_fee || 0),
      })?.transactionFee;

      setTransactionPrice(parseFloat(transaction_fee));
      setTaxPrice(parseFloat(tax));
      setTotalPrice(parseFloat(total_price + transaction_fee + tax));
      setSubtotal(parseFloat(orderTotal));
    } else {
      setTotalPrice(parseFloat(0));
    }
  }, [eventOrganizer?.data?.feeSetting, checkoutData]);

  return checkoutData &&
    Array.isArray(checkoutData) &&
    checkoutData?.length > 0 ? (
    <div className="bg-white w-full py-5 md:py-6 px-5 md:px-8 rounded-3xl">
      <div className="text-slate-900 text-xl font-bold capitalize mb-5">
        {t("Order summary")}
      </div>
      <div className="relative space-y-2 pb-4 border-b border-slate-200">
        {checkoutData?.map((item, i) => (
          <div
            key={i?.toString()}
            className="flex items-center justify-between gap-4"
          >
            {item?.buy_quentity > 0 && (
              <>
                <div className="flex-shrink text-slate-500 text-sm md:text-lg font-medium ">
                  {item?.buy_quentity} x {lngDetect(item?.name)}
                </div>
                <div className="flex-shrink-0 text-slate-500 text-sm md:text-lg font-medium">
                  {event?.data?.currency?.symbol || "$"}
                  {parseFloat(item?.totalPrice).toFixed(2)}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      <div className="relative space-y-2 pt-4 pb-4 border-b border-slate-200">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-shrink text-slate-500 text-sm md:text-lg font-medium ">
            {t("Subtotal")}
          </div>
          <div className="flex-shrink-0 text-slate-500 text-sm md:text-lg font-medium">
            {event?.data?.currency?.symbol || "$"}
            {subTotal?.toFixed(2)}
          </div>
        </div>
        <div className="flex items-center justify-between gap-4">
          <div className="flex-shrink text-slate-500 text-sm md:text-lg font-medium ">
            {t("Transaction fee")}
          </div>
          <div className="flex-shrink-0 text-slate-500 text-sm md:text-lg font-medium">
            {event?.data?.currency?.symbol || "$"}
            {transactionPrice?.toFixed(2)}
          </div>
        </div>
        <div className="flex items-center justify-between gap-4">
          <div className="flex-shrink text-slate-500 text-sm md:text-lg font-medium ">
            {(eventOrganizer?.data?.taxData &&
              Array.isArray(eventOrganizer?.data?.taxData) &&
              eventOrganizer?.data?.taxData?.[0]?.name) ||
              t("Tax fee")}
          </div>
          <div className="flex-shrink-0 text-slate-500 text-sm md:text-lg font-medium">
            {event?.data?.currency?.symbol || "$"}
            {taxPrice?.toFixed(2)}
          </div>
        </div>
      </div>
      <div className="relative space-y-2 pt-4 pb-4 border-b border-slate-200">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-shrink text-slate-900 text-sm md:text-lg font-bold ">
            {t("Total")}
          </div>
          <div className="flex-shrink-0 text-slate-900 text-sm md:text-lg font-bold">
            {event?.data?.currency?.symbol || "$"}
            {totalPrice?.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-white w-full py-6 px-8 rounded-lg flex flex-col items-center justify-center">
      <NoData image={noDataImage} message={t("Tickets not selected")} />
    </div>
  );
};

export default OrderSummaryInfo;
